import logo from './logo.svg';
import './App.css';
import Layouts from './layout/layouts';

function App() {
  return (
   <>
   <Layouts/>
   </>
  );
}

export default App;
